import React from 'react';
import {
    PaintBrushIcon,
    Cog6ToothIcon,
    ClockIcon,
    DocumentArrowUpIcon,
    DocumentArrowDownIcon,
    PlayIcon
} from '@heroicons/react/24/outline';
import { useTranslation } from "react-i18next";

const MobileToolbarButton = ({ onClick, title, children, disabled = false }) => (
    <button
        onClick={onClick}
        title={title}
        disabled={disabled}
        className={`flex flex-col items-center justify-center space-y-1 p-2 rounded-lg transition-colors w-16 h-16 ${disabled ? 'text-gray-400' : 'text-gray-700 hover:bg-gray-200'}`}
    >
        {children}
    </button>
);

const MobileToolbar = ({ onToggleElements, onToggleProperties, propertiesAvailable, onOpenHistory, onLoadProject, onSaveProject, onOpenInstructionModal }) => {
    const { t } = useTranslation();

    return (
        <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-300 shadow-top z-30 flex justify-around">
            <MobileToolbarButton onClick={onToggleElements} title={t('elementSelectionPanel.title')}>
                <PaintBrushIcon className="w-6 h-6" />
                <span className="text-xs">{t('elementSelectionPanel.title')}</span>
            </MobileToolbarButton>

            <MobileToolbarButton onClick={onToggleProperties} title={t('propertiesPanel.title')} disabled={!propertiesAvailable}>
                <Cog6ToothIcon className="w-6 h-6" />
                <span className="text-xs">{t('propertiesPanel.title')}</span>
            </MobileToolbarButton>

            <MobileToolbarButton onClick={onOpenInstructionModal} title={t('instructions.button')}>
                <PlayIcon className="w-6 h-6 text-primary-blue" />
                <span className="text-xs">{t('instructions.button')}</span>
            </MobileToolbarButton>

            <MobileToolbarButton onClick={onOpenHistory} title={t('toolbar.history_open')}>
                <ClockIcon className="w-6 h-6" />
                <span className="text-xs">{t('history.title')}</span>
            </MobileToolbarButton>

            <MobileToolbarButton onClick={onSaveProject} title={t('toolbar.save_project_file')}>
                <DocumentArrowDownIcon className="w-6 h-6" />
                <span className="text-xs">{t('toolbar.save_project_file')}</span>
            </MobileToolbarButton>

            <MobileToolbarButton onClick={onLoadProject} title={t('toolbar.load_project_file')}>
                <DocumentArrowUpIcon className="w-6 h-6" />
                <span className="text-xs">{t('toolbar.load_project_file')}</span>
            </MobileToolbarButton>
        </div>
    );
};

export default MobileToolbar;